import { HttpClient } from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { catchError } from 'rxjs/operators';
import { IEffortDto, IOrchestrationDto, IOrchestrationTargetingRuleDto, ITargetingRuleDto } from '../../models/orchestrations';
import { ConfigurationService } from '../configuration/configuration.service';
import { EndpointFactory } from '../endpoint-factory.service';

@Injectable({
  providedIn: 'root'
})
export class OrchestrationEndpointService extends EndpointFactory {

    constructor(http: HttpClient, configurations: ConfigurationService, injector: Injector) {
        super(http, configurations, injector, '', configurations.webAppApiBaseUrl);
    }

    public getEfforts(): Promise<IEffortDto[]> {
    const url = `${this.url}Effort`;
    return this.http.get<IEffortDto[]>(url).pipe(
        catchError(error => {
            return this.handleError(error);
        })).toPromise();
    }

    public getOrchestrations(): Promise<IOrchestrationDto[]> {
        const url = `${this.url}Orchestration`;
        return this.http.get<IOrchestrationDto[]>(url).pipe(
            catchError(error => {
                return this.handleError(error);
            })).toPromise();
        }

    public getOrchestrationTargetingRules(): Promise<IOrchestrationTargetingRuleDto[]> {
        const url = `${this.url}OrchestrationTargetingRule`;
        return this.http.get<IOrchestrationTargetingRuleDto[]>(url).pipe(
            catchError(error => {
                return this.handleError(error);
            })).toPromise();
        }

    public getTargetingRules(): Promise<ITargetingRuleDto[]> {
        const url = `${this.url}TargetingRule`;
        return this.http.get<ITargetingRuleDto[]>(url).pipe(
            catchError(error => {
                return this.handleError(error);
            })).toPromise();
        }

    //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

    saveDeleteTargetingRuleChange(request: ITargetingRuleDto): Promise<ITargetingRuleDto> {
        const url = `${this.url}TargetingRule/${request.id}`;
        return this.http.delete<ITargetingRuleDto>(url).pipe(
            catchError(error => {
                return this.handleError(error);
            })).toPromise();
    }

    saveDeleteOrchestrationTargetingRuleChange(request: IOrchestrationTargetingRuleDto): Promise<IOrchestrationTargetingRuleDto> {
        const url = `${this.url}OrchestrationTargetingRule/${request.id}`;
        return this.http.delete<IOrchestrationTargetingRuleDto>(url).pipe(
            catchError(error => {
                return this.handleError(error);
            })).toPromise();
    }

    saveDeleteOrchestrationChanges(request: IOrchestrationDto): Promise<IOrchestrationDto> {
        const url = `${this.url}Orchestration/${request.id}`;
        return this.http.delete<IOrchestrationDto>(url).pipe(
            catchError(error => {
                return this.handleError(error);
            })).toPromise();
    }

    saveDeleteEffortChanges(request: IEffortDto): Promise<IEffortDto> {
        const url = `${this.url}Effort/${request.id}`;
        return this.http.delete<IEffortDto>(url).pipe(
            catchError(error => {
                return this.handleError(error);
            })).toPromise();
    }

    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////

    saveCreateTargetingRuleChange(request: ITargetingRuleDto): Promise<ITargetingRuleDto> {
        const url = `${this.url}TargetingRule`;
        return this.http.post<ITargetingRuleDto>(url, request).pipe(
            catchError(error => {
                return this.handleError(error);
            })).toPromise();
    }

    saveCreateOrchestrationTargetingRuleChange(request: IOrchestrationTargetingRuleDto): Promise<IOrchestrationTargetingRuleDto> {
        const url = `${this.url}OrchestrationTargetingRule`;
        return this.http.post<IOrchestrationTargetingRuleDto>(url, request).pipe(
            catchError(error => {
                return this.handleError(error);
            })).toPromise();
    }

    saveCreateOrchestrationChanges(request: IOrchestrationDto): Promise<IOrchestrationDto> {
        const url = `${this.url}Orchestration`;
        return this.http.post<IOrchestrationDto>(url, request).pipe(
            catchError(error => {
                return this.handleError(error);
            })).toPromise();
    }

    saveCreateEffortChanges(request: IEffortDto): Promise<IEffortDto> {
        const url = `${this.url}Effort`;
        return this.http.post<IEffortDto>(url, request).pipe(
            catchError(error => {
                return this.handleError(error);
            })).toPromise();
    }

    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

    saveTargetingRuleChange(request: ITargetingRuleDto): Promise<ITargetingRuleDto> {
        const url = `${this.url}TargetingRule`;
        return this.http.put<ITargetingRuleDto>(url, request).pipe(
            catchError(error => {
                return this.handleError(error);
            })).toPromise();
    }

    saveOrchestrationTargetingRuleChange(request: IOrchestrationTargetingRuleDto): Promise<IOrchestrationTargetingRuleDto> {
        const url = `${this.url}OrchestrationTargetingRule`;
        return this.http.put<IOrchestrationTargetingRuleDto>(url, request).pipe(
            catchError(error => {
                return this.handleError(error);
            })).toPromise();
    }

    saveOrchestrationChanges(request: IOrchestrationDto): Promise<IOrchestrationDto> {
        const url = `${this.url}Orchestration`;
        return this.http.put<IOrchestrationDto>(url, request).pipe(
            catchError(error => {
                return this.handleError(error);
            })).toPromise();
    }

    saveEffortChanges(request: IEffortDto): Promise<IEffortDto> {
        const url = `${this.url}Effort`;
        return this.http.put<IEffortDto>(url, request).pipe(
            catchError(error => {
                return this.handleError(error);
            })).toPromise();
    }
}
